import React from 'react';
import { useIntl } from 'react-intl';
import classnames from 'classnames';
import messages from './messages';
import styles from './TryInStoreButton.module.scss';

const TryInStoreButton = ({ onClick }: { onClick: () => void }) => {
  const { formatMessage } = useIntl();
  return (
    <button
      className={classnames('btn', styles['secondary-button'])}
      onClick={onClick}
      data-testid="secondary-button"
      id='try-in-store-button'
      type="button"
    >
      {formatMessage(messages.title)}
    </button>
  );
};

export default TryInStoreButton;
